export const formatVND = (amount: number) => {
    return new Intl.NumberFormat('vi-VN', {
        // style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};
